var map = {
	"./article/0.jpeg": 2306,
	"./article/1.jpeg": 2937,
	"./article/10.jpeg": 3879,
	"./article/11.jpeg": 6832,
	"./article/12.jpeg": 5121,
	"./article/13.jpeg": 2170,
	"./article/14.jpeg": 6619,
	"./article/15.jpeg": 3876,
	"./article/16.jpeg": 869,
	"./article/17.jpeg": 5310,
	"./article/18.jpeg": 1423,
	"./article/19.jpeg": 3528,
	"./article/2.jpeg": 9192,
	"./article/20.jpeg": 2136,
	"./article/21.jpeg": 655,
	"./article/22.jpeg": 3138,
	"./article/23.jpeg": 9817,
	"./article/24.jpeg": 2204,
	"./article/25.jpeg": 9139,
	"./article/26.jpeg": 1126,
	"./article/27.jpeg": 9869,
	"./article/28.jpeg": 256,
	"./article/29.jpeg": 1175,
	"./article/3.jpeg": 7087,
	"./article/30.jpeg": 9657,
	"./article/31.jpeg": 7458,
	"./article/32.jpeg": 1055,
	"./article/33.jpeg": 3640,
	"./article/34.jpeg": 141,
	"./article/35.jpeg": 6918,
	"./article/4.jpeg": 6902,
	"./article/5.jpeg": 8237,
	"./article/6.jpeg": 1708,
	"./article/7.jpeg": 8387,
	"./article/8.jpeg": 7834,
	"./article/9.jpeg": 785,
	"./line_chat.jpeg": 6826,
	"./logo.svg": 3935,
	"./logo_white.webp": 2228,
	"./ltk_logo_black.png": 6419,
	"./ltk_logo_white.png": 8333,
	"./report.jpeg": 6263,
	"./whatsapp_line.001.jpeg": 2467,
	"./wx_live_chat.jpeg": 1896
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;